import { useOktaAuth } from "@okta/okta-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function RequireAuth() {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (authState === null) {
    return (
      <div className="app">
        <div className="loader-container" style={{ padding: "4rem", textAlign: "center" }}>
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem" }} />
        </div>
      </div>
    );
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
